module.exports = __webpack_public_path__ + "static/media/desktop-svk-lenta.656ac70e.gif";